import { render, staticRenderFns } from "./DesmatamentoEudr.vue?vue&type=template&id=3d75acd5&lang=pug"
import script from "./DesmatamentoEudr.vue?vue&type=script&lang=js"
export * from "./DesmatamentoEudr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports